<template>
  <div class="gc-container">
    <GiftCardHeader/>

    <div class="container">

      <div class="white-box">
        <h2>{{ wpOptions.sum_title }}</h2>
        <ul class="selected-cards">
          <li v-for="(card,i) in cardsToPayFor" :key="i">
            <span class="quantity">{{ card.quantity }} × &nbsp;</span>
            <span class="quantity">גיפט קארד בשווי ₪{{ card.cash_value }}</span>
            <span class="spacing">אאא</span>
            <span class="subtotal">₪{{ parseInt(card.cash_value) * parseInt(card.quantity) }}</span>
          </li>
          <li class="sum">
            <div class="spacer"></div>
            <span>סה״כ לתשלום: </span>
            <span>₪{{ sumToPay }}</span>
          </li>
        </ul>
      </div>

      <div class="white-box" :class="{ 'loading': this.loading_saved_credit_cards }">
        <div class="blanket"></div>
        <h2>{{ wpOptions.credit_cards_title }}</h2>
        <ul class="credit-cards">
          <li>
            <input type="radio" id="new-credit-card" value="new_credit_card" v-model="payment_method">
            <label for="new-credit-card">
              <em>בכרטיס אשראי {{ savedCreditCards !== null && savedCreditCards.length > 0 ? 'חדש' : '' }}</em>
              <span v-if="$store.state.userLoggedInfo">(לא יישמר לרכישות הבאות)</span>
            </label>
          </li>
          <li v-for="creditCard in savedCreditCards" :key="creditCard.card">
            <input type="radio" :id="'digits-' + creditCard.card" :value="creditCard.id" v-model="payment_method">
            <label :for="'digits-' + creditCard.card">
              <em>בכרטיס אשראי שמור</em>
              <span>מסתיים בספרות {{ creditCard.card }}, בתוקף עד {{ creditCard.expiredate }}</span>
            </label>
          </li>
        </ul>

        <div class="terms-container">
          <label class="form_check" v-if="!this.$store.state.userLogged ||  this.$store.state.userLoggedInfo.terms != '1' || this.$store.state.isAdmin ">
            <div class="form_check_tx">
              קראתי ואישרתי את
              <a-div :force-new="true" :href="this.$wpData.terms_page">תנאי שימוש</a-div>
              <input
                  type="checkbox"
                  name="terms"
                  v-validate="'required'"
                  value="קראתי ואישרתי את תנאי השימוש"
                  data-vv-validate-on="input"
              />
              <span class="checkmark"></span>
            </div>
            <div class="error_tx">{{ errors.first("terms") }}</div>
          </label>
          <label
              class="form_check"
              v-if="!this.$store.state.userLogged || this.$store.state.userLoggedInfo.subscribed != '1'"
          >
            <div class="form_check_tx">
              אני רוצה לקבל עדכונים לגבי מבצעים והפתעות עונתיות במייל
              <input
                  type="checkbox"
                  name="account_subscribe"
                  checked
                  value="1"
              />
              <span class="checkmark"></span>
            </div>
          </label>
        </div>

        <button id="submit" @click="submitOrder()">
          <span>{{ wpOptions.pay_button_text }}</span>
          <img id="gc-submit-loader" :src="wpData.assets_url + '/svg/loader.svg'" alt="">
        </button>

        <p class="submit-error hidden">{{ wpOptions.general_error }}</p>
        <p class="j5-error hidden">{{ wpOptions.j5_error }}</p>

      </div>

    </div>

    <GiftCardNav :step=3 :buttonDisabled=true></GiftCardNav>
  </div>
</template>

<script>

import GiftCardHeader from "../../components/GiftCard/GiftCardHeader.vue";
import GiftCardNav from "../../components/GiftCard/GiftCardNav.vue";
import OrderEnter from "../../views/OrderEnter.vue";

import {mapGetters} from "vuex";

export default {

  name: 'Pay',
  metaInfo: {
    title: wpData.globalOptions.gc_page_purchase.seo_title,
    meta: [{
      name: 'description',
      content: wpData.globalOptions.gc_page_purchase.seo_desc
    }]
  },
  data() {
    return {
      wpData: wpData,
      wpOptions: wpData.globalOptions.gc_page_pay,
      cards: this.$store.state.giftCardPurchase,
      savedCreditCards: null,
      payment_method: 'new_credit_card',
      loading_saved_credit_cards: false,
      userLoggedInfo: this.$store.state.userLoggedInfo
    }
  },
  watch: {
    orderAsEmail: function () {
      this.getSavedCardsFromServer();
    }
  },
  methods: {
    getSavedCardsFromServer() {
      if (this.$wpData.user.saved_cards) {
        this.savedCreditCards = this.$wpData.user.saved_cards;
        this.payment_method = this.$wpData.user.saved_cards[0].id;
      } else {
        return false;
      }

      // fetch( wpData.ajax_url + "?action=getCards&orderAs=" + this.orderAsEmail)
      // 	.then( res => { this.loading_saved_credit_cards = false; return res.json(); } )
      // 		.then( data => {
      // 			if ( ! data.hasOwnProperty('cards') ) { return false; }
      // 			this.savedCreditCards = data.cards;
      // 			this.payment_method = data.cards[0].id;
      // 		});
    },
    submitOrder() {
      this.$validator.validate().then(success => {
        if (success) {
          const button = document.querySelector('#submit');
          if (button.classList.contains('loading')) {
            return false;
          }
          button.classList.add('loading');

          const wpUserID = this.userCheckoutInfo.id;
          let values = [];
          this.cardsToPayFor.forEach(card => {
            for (var i = 0; i < card.quantity; i++) {
              values.push(parseInt(card.cash_value));
            }
          });

          // Prepare payload
          let payload = new FormData();
          payload.append('wordpress_user_id', wpUserID);
          payload.append('values', values);
          payload.append('send_details', this.generateCardSendDetails());
          if (this.payment_method !== 'new_credit_card') {
            payload.append('token', this.savedCreditCards.find(savedCreditCard => savedCreditCard.id === this.payment_method).token);
          }

          // Send the request
          fetch(wpData.ajax_url + "?action=cgc_createOrder", {
            method: 'POST',
            body: payload
          }).then(r => r.json()).then(r => {
            console.log(r);
            if (!r.success) {
              document.querySelector('.submit-error').classList.remove('hidden');
              button.classList.remove('loading');
              return false;
            }

            if (this.payment_method !== 'new_credit_card' && !r.order_paid) { // If tried to pay using saved card and it failed
              button.classList.remove('loading');
              document.querySelector('.j5-error').classList.remove('hidden');
              return false;
            }
            if (r.order_paid) {
              const thankYouPath = './thank-you/' + r.order_id + '/' + r.order_key;
              this.$router.push({path: thankYouPath});
              return true;
            } else {
              localStorage.setItem('carmella-payform', '"' + JSON.parse(r.payment_iframe_url) + '"');
              this.$store.state.paymentIframe = JSON.parse(r.payment_iframe_url);
              const iframeUrl = r.payment_url.replace(wpData.home_url, '..') + '&is_gift_card_purchase=true';
              this.$router.push({path: iframeUrl});
              return true;
            }
          });
        }
      });
    },
    generateCardSendDetails() {
      let cardData = [];
      let cards = this.$store.state.giftCardPurchaseSelectedCards;
      cards.forEach(card => {
        cardData.push({
          cash_value: card.cash_value,
          ...card.send_details,
          giver_name: this.$store.state.giftCardPurchaseGiverName,
          form: this.$store.state.giftCardForm
        });
      });
      return JSON.stringify(cardData);
    }
  },
  computed: {
    ...mapGetters(['userCheckoutInfo']),
    selectedCards() {
      return this.$store.state.giftCardPurchaseSelectedCards;
    },
    cardsToPayFor() {
      return this.cards.filter(card => card.quantity > 0);
    },
    sumToPay() {
      return this.cards.reduce((sum, card) => sum + parseInt(card.quantity) * parseInt(card.cash_value), 0);
    },
    orderAsEmail() {
      if (this.userCheckoutInfo.newUser) {
        return "0";
      }
      return this.userCheckoutInfo.email;
    }
  },
  mounted() {

    // if (!this.$store.state.userLoggedInfo) {
    //   this.$router.push({
    //     name: "orderEnter",
    //     params: {
    //       redirectTo: '/gift-card/pay',
    //       message: 'לביצוע הזמנה עליך להתחבר לאתר'
    //     },
    //   });
    // }


    /* FOR DEBUGGING */
    // this.$set( this.$store.state, 'giftCardPurchaseSelectedCards', [{"title":"כרטיס מגניב של מאה שקל","desc":"לורם איפסום דולור סיט אמת וזה וזה ועוד טקסט","cash_value":"1","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":1,"restored":false,"send_details":{"method":"their_mail","name":"ראשון של מאה","email":"somemail1@one.com","phone":"","message":"הדקשנה וזה וזה"}},{"title":"כרטיס מגניב של מאה שקל","desc":"לורם איפסום דולור סיט אמת וזה וזה ועוד טקסט","cash_value":"1","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":1,"restored":false,"send_details":{"method":"sms","name":"שני של מאה","email":"","phone":"0543162916","message":""}},{"title":"גיפט קארד מגניב בינוני","desc":"רמת מגניבות בינונית בהחלט","cash_value":"2","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-2@3x.png","quantity":1,"restored":false,"send_details":{"method":"my_mail","name":"ראשון של  מאתיים","email":"","phone":"","message":""}}] );
    // this.$set( this, 'cards', [{"title":"כרטיס מגניב של מאה שקל","desc":"לורם איפסום דולור סיט אמת וזה וזה ועוד טקסט","cash_value":"1","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":2},{"title":"גיפט קארד מגניב בינוני","desc":"רמת מגניבות בינונית בהחלט","cash_value":"2","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-2@3x.png","quantity":1},{"title":"סתם שם שךא מוצג בכלל","desc":"כמעט הכי מגניב שווה לנסות","cash_value":"3","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":0},{"title":"לא מוצג","desc":"הכי הכי שווה והכי הכי מגניב","cash_value":"4","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-2@3x.png","quantity":0}] );
    /* END DEBUGGING */

    if (this.selectedCards.length === 0) { // If no cards selected navigate to first step 'purchase'
      this.$router.push({path: './purchase'});
    }

    document.querySelector('#submit').classList.remove('loading');

    // Check if user logged in
    if (this.orderAsEmail) {
      this.getSavedCardsFromServer();
    }

  },
  components: {
    GiftCardHeader,
    GiftCardNav,
    OrderEnter
  }
}
</script>

<style lang="sass" scoped>

@import '../../assets/sass/gift-card-abstracts.sass'

.white-box
  position: relative
  max-width: 59rem
  margin: 3rem 0
  padding: 2rem
  background-color: $white
  border-radius: 0.5rem
  font-family: simpler, Sans-Serif
  box-shadow: 0 0.5rem 1rem 0 rgba(darken($bg, 40%), 0.2)

  .blanket
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-color: rgba($white, 0.9)
    z-index: 2
    display: none

  &.loading .blanket
    display: block


h2
  color: $dark
  font-size: 1.5rem
  font-weight: bold
  margin-bottom: 1rem

ul li
  list-style-type: none
  padding: 0

  &:before
    display: none

li.sum
  font-weight: bold

.spacing
  opacity: 0

.spacer
  border-top: 1px solid lighten($black, 80%)
  margin: 0.5rem 0
  width: 14rem

#submit
  font-size: 1.25rem
  background: $main
  color: $white
  border: none
  outline: none
  padding: 0.5rem 2rem
  border-radius: 5rem
  margin: 1rem 0 0 0
  position: relative
  +mobile
    width: 100%

  &:hover, &:focus
    background-color: lighten($main, 4%)

  &:active
    background-color: lighten($main, 7%)

#submit.loading
  span
    opacity: 0

  #gc-submit-loader
    opacity: 1

#gc-submit-loader
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  opacity: 0

.submit-error, .j5-error
  color: $error
  margin-top: 0.25rem

input[type="radio"]
  display: none

input[type="radio"] + label
  cursor: pointer

input[type="radio"] + label:before
  content: ''
  display: inline-block
  margin-left: 4px
  border-radius: 100%
  width: 1.15rem
  height: 1.15rem
  background-color: $white
  border: 3px solid $white
  box-shadow: 0 0 1px 1px rgba($dark, 0.8)
  transform: translateY(5px)

input[type="radio"]:checked + label:before
  background-color: $main

.head_order
  display: none !important

.credit-cards li
  line-height: 1.15
  margin: 0.15rem 0 0.25rem 0

  label
    em
      display: inline-block
      font-style: normal
      padding-right: 0.25rem

    span
      font-weight: normal
      opacity: 0.65
      display: block
      padding-right: 1.55rem
      white-space: nowrap

.terms-container
  margin-top: 1.5em

  label
    margin-bottom: 5px
</style>